'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRedux = require('react-redux');

var _UICloseButton = require('UIComponents/button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _UIProductActivationButton = require('ui-addon-upgrades/button/UIProductActivationButton');

var _UIProductActivationButton2 = _interopRequireDefault(_UIProductActivationButton);

var _getFeatureDescriptionKey = require('self-service-api/core/utilities/getFeatureDescriptionKey');

var _getFeatureDescriptionKey2 = _interopRequireDefault(_getFeatureDescriptionKey);

var _colors = require('HubStyleTokens/colors');

var _Tracking = require('pricing-pages-unified-ui/constants/Tracking');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _MerchandiseIdsToUpgradeProducts = require('self-service-api/constants/MerchandiseIdsToUpgradeProducts');

var _ProductOwnershipSelectors = require('../../selectors/ProductOwnershipSelectors');

var _EnvironmentWrapper = require('pricing-pages-unified-ui/components/EnvironmentWrapper');

var _EnvironmentWrapper2 = _interopRequireDefault(_EnvironmentWrapper);

var _UIBadge = require('UIComponents/badge/UIBadge');

var _UIBadge2 = _interopRequireDefault(_UIBadge);

var _stringUtils = require('pricing-pages-unified-ui/utils/stringUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBodyContainer = _styledComponents2.default.div.withConfig({
  displayName: 'FeaturesModal__ModalBodyContainer'
})(['padding:40px;']);

var ModalHeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'FeaturesModal__ModalHeaderContainer'
})(['background-color:', ';height:70px;width:100%;border-bottom:1px solid ', ';display:flex;align-items:center;padding-left:40px;padding-right:20px;'], _colors.GYPSUM, _colors.KOALA);

var ModalHeader = _styledComponents2.default.div.withConfig({
  displayName: 'FeaturesModal__ModalHeader'
})(['flex-grow:1;font-size:20px;font-weight:600;']);

var FeatureText = (0, _styledComponents2.default)(_FormattedMessage2.default).withConfig({
  displayName: 'FeaturesModal__FeatureText'
})(['font-size:16px;']);

var FeaturesModal = function FeaturesModal(_ref) {
  var header = _ref.header,
      features = _ref.features,
      onModalClose = _ref.onModalClose,
      merchandiseId = _ref.merchandiseId,
      hubType = _ref.hubType,
      isUnactivated = _ref.isUnactivated;
  return _react2.default.createElement(
    _UIModal2.default,
    { onOverlayClick: onModalClose },
    _react2.default.createElement(
      ModalHeaderContainer,
      null,
      _react2.default.createElement(
        ModalHeader,
        null,
        header
      ),
      _react2.default.createElement(_UICloseButton2.default, { color: _colors.OBSIDIAN, onClick: onModalClose })
    ),
    _react2.default.createElement(
      ModalBodyContainer,
      null,
      Object.keys(features).map(function (key) {
        return _react2.default.createElement(
          'div',
          { key: key, className: 'm-bottom-5' },
          _react2.default.createElement(_UIIcon2.default, { name: 'success', className: 'm-right-4' }),
          _react2.default.createElement(
            _UITooltip2.default,
            {
              placement: 'right',
              title: _react2.default.createElement(_FormattedMessage2.default, {
                message: (0, _getFeatureDescriptionKey2.default)(key, hubType)
              })
            },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block' } },
              _react2.default.createElement(FeatureText, { message: 'pricing-pages.features.' + key + '.name' }),
              features[key].isNew && (0, _stringUtils.hasStringTranslation)('pricingPage.new') && _react2.default.createElement(
                _UIBadge2.default,
                { use: 'new', className: 'm-left-1' },
                _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.new' })
              )
            )
          )
        );
      }),
      _react2.default.createElement(_EnvironmentWrapper2.default, {
        authedNode: isUnactivated && merchandiseId && _react2.default.createElement(_UIProductActivationButton2.default, {
          'data-selenium-id': 'product-activation-button',
          className: 'm-top-4',
          upgradeData: {
            app: _Tracking.APP,
            screen: _Tracking.SUBSCREENS.FREE_TOOLS_CRM,
            uniqueId: 'activate-tools',
            upgradeProduct: _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[merchandiseId]
          },
          onSuccess: onModalClose
        })
      })
    )
  );
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId;
  return {
    isUnactivated: (0, _ProductOwnershipSelectors.isUnactivatedFreeProductSelector)(state, merchandiseId)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(FeaturesModal);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/free-tools-page/FeaturesModal.js
// module id = 431
// module chunks = 3 4